import Routes from "router/routes";
import { KroButton } from "features/components/buttons/kroButton";
import { useNavigate } from "react-router-dom";

const EmptyCampaignCard = () => {
  const navigate = useNavigate();
  return (
    <div className="mx-auto flex flex-col items-center justify-center lg:w-[524px]">
      <img src="/assets/icons/empty-campaign.svg" alt="empty-campaign" />
      <p className="mt-5 text-[20px] font-semibold text-strong-950">
        No Campaigns
      </p>
      <p className="mt-5 text-center font-inter text-[16px] font-normal leading-[24px] tracking-[-1.5%] text-neutral-700">
        You do have not created a campaign. To start raising, click the button
        below to create your very first Giv Campaign
      </p>
      <KroButton
        title="Start a Fundraiser"
        className="mt-7 h-9"
        iconSize={7}
        onclick={() => navigate(Routes.CREATE_CAMPAIGN)}
      />
    </div>
  );
};

export default EmptyCampaignCard;
